import { render, staticRenderFns } from "./instagramStory.vue?vue&type=template&id=66f40b30&scoped=true&lang=html&"
import script from "./instagramStory.vue?vue&type=script&lang=js&"
export * from "./instagramStory.vue?vue&type=script&lang=js&"
import style0 from "./instagramStory.vue?vue&type=style&index=0&id=66f40b30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f40b30",
  null
  
)

export default component.exports